import config from "../config/config";
import { getToken } from "../utils/prefix";

export async function submit_model(data) {
  const res = await fetch(config.api_backend + `/submission/create`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_submit(data) {
  const res = await fetch(config.api_backend + `/submission/get`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function queue_submit(data) {
  const res = await fetch(config.api_backend + `/submission/queue`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_model(data) {
  const res = await fetch(config.api_backend + `/submission/image/list`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_tutorial(data) {
  const res = await fetch(config.api_backend + `/submission/image/tutorial`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_task_tutorial(data) {
  const res = await fetch(config.api_backend + `/submission/task/tutorial`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function submit_draft(data) {
  const res = await fetch(config.api_backend + `/submission/draft`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function submit_draft_delete(data) {
  const res = await fetch(config.api_backend + `/submission/deleteDraft`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_getSubmission(data) {
  const res = await fetch(config.api_backend + `/submission/get`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_getLimitSubmission(data) {
  const res = await fetch(config.api_backend + `/submission/getchecklimit`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_leaderboardScore(data) {
  const res = await fetch(config.api_backend + `/submission/leaderboardscore`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_SubmissionDraft(data) {
  const res = await fetch(config.api_backend + `/submission/getdraft`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_SubmissionRoleUser(data) {
  const res = await fetch(config.api_backend + `/submission/checkmyrole`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function del_SubmissionRow(data) {
  const res = await fetch(config.api_backend + `/submission/deleterow`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_apiSubmissionShow(data) {
  const res = await fetch(
    config.api_backend + `/submission/changeshowleaderboard`,
    {
      body: JSON.stringify(data),
      method: "POST",
      headers: {
        "x-access-token": getToken(),
        "Content-type": "application/json",
      },
    },
  );

  const dataRespone = await res.json();
  return dataRespone;
}
export async function api_testEval(data) {
  const res = await fetch(config.api_backend + `/submission/testeval`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}
export async function api_testInfer(data) {
  const res = await fetch(config.api_backend + `/submission/testinfer`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}
